import * as React from "react";
import { Col, Row } from "antd";
import * as moment from "moment";
import { Dispatch, SetStateAction } from "react";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { PbrInputCpf } from "src/components/common/PbrInputCpf/PbrInputCpf";
import { PbrInputDate } from "src/components/common/PbrInputDate/PbrInputDate";
import { PbrInputEmail } from "src/components/common/PbrInputEmail/PbrInputEmail";
import { FormComponentProps } from "antd/lib/form";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import "./EditTradeSpouse.scss";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import ISpouse from "src/services/interfaces/ISpouse";
import { objectPropsUpdate } from 'src/util/objectUtils';
import { UploadDocumentButton } from 'src/components/Refatoracao/UploadDocument/UploadDocumentButton';
import { DocumentCategoryEnum } from 'src/components/Refatoracao/UploadDocument/DocumentCategoryEnum';
import { StorageTypeEnum } from 'src/components/Refatoracao/UploadDocument/StorageTypeEnum';
import { EditRG } from '../EditRG/EditRG';

interface IEditTradeSpouse {
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  trade: ITrade;
  setTrade: Dispatch<SetStateAction<ITrade>>;
  title: string;
  isTradeSpouseRequired: boolean;
  isIssuingAuthorityRequired: boolean;
  isRGDateRequired: boolean;
}

export function EditTradeSpouse(props: IEditTradeSpouse & FormComponentProps) {
  const handleSpouseChange = (value: ISpouse) => {
    props.setTrade((obj) => objectPropsUpdate(obj, {
      tradeOwner: objectPropsUpdate(obj.tradeOwner, {
        spouse: objectPropsUpdate(obj.tradeOwner.spouse, value)
      })
    }));
  }

  return (
    <PbrCard className="default-tabs" title={props.title} bordered={false} style={{ width: "100%" }}>
      <Row gutter={30}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInput
            name="spouseName"
            formWrapper={props.form}
            placeholder="Nome do cônjuge"
            formItemProps={{ label: "Nome do Cônjuge" }}
            value={props.trade.tradeOwner.spouse ? props.trade.tradeOwner.spouse?.fullName : null}
            onChange={e => handleSpouseChange({ fullName: e.target.value })}
            rules={[{ required: true, message: "Informe o nome do cônjuge" }]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInputEmail
            name="spouseEmail"
            formWrapper={props.form}
            placeholder="E-mail do cônjuge"
            formItemProps={{ label: "E-mail do Cônjuge" }}
            value={props.trade.tradeOwner.spouse ? props.trade.tradeOwner.spouse?.email : null}
            onChange={e => handleSpouseChange({ email: e.target.value })}
            rules={[{ required: props.isTradeSpouseRequired, message: "Informe o email do Cônjuge" }]}
          />
        </Col>
      </Row>

      <Row gutter={30}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInputCpf
            name="spouseCpf"
            formWrapper={props.form}
            placeholder={"CPF do Cônjuge"}
            formItemProps={{ label: "CPF do Cônjuge" }}
            allowCnpj={false}
            value={props.trade.tradeOwner.spouse ? props.trade.tradeOwner.spouse?.cpf : null}
            onChange={e => handleSpouseChange({ cpf: e.target.value })}
            rules={[{ required: true, message: "Informe o CPF do Cônjuge" }]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInputDate
            name="spouseBirthDate"
            formWrapper={props.form}
            placeholder={"Informe a data de nascimento do Cônjuge"}
            formItemProps={{ label: "Data de nascimento do Cônjuge" }}
            value={props.trade.tradeOwner.spouse?.birthDate}
            isRequired={props.isTradeSpouseRequired}
            requiredMessage="Data de nascimento do Cônjuge é obrigatória"
            onChange={e => handleSpouseChange({ birthDate: moment(e) })}
          />
        </Col>
      </Row>

      <EditRG
        trade={props.trade}
        onChange={handleSpouseChange}
        form={props.form}
        isOwnerRG={false}
        isRGrequired={props.isTradeSpouseRequired}
        isRGDateRequired={props.isRGDateRequired}
        isIssuingAuthorityRequired={props.isIssuingAuthorityRequired}
      />

      <Row gutter={30}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInput
            name="spouseNationality"
            formWrapper={props.form}
            placeholder={"Nacionalidade do Cônjuge"}
            formItemProps={{ label: "Nacionalidade do Cônjuge" }}
            value={props.trade.tradeOwner.spouse ? props.trade.tradeOwner.spouse?.nationality : null}
            onChange={e => handleSpouseChange({ nationality: e.target.value })}
            rules={[{ required: props.isTradeSpouseRequired, message: "Informe a nacionalidade do Cônjuge" }]}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInput
            name="spouseProfession"
            formWrapper={props.form}
            placeholder={"Profissão do Cônjuge"}
            formItemProps={{ label: "Profissão do Cônjuge" }}
            value={props.trade.tradeOwner.spouse ? props.trade.tradeOwner.spouse?.profession : null}
            onChange={e => handleSpouseChange({ profession: e.target.value })}
            rules={[{ required: props.isTradeSpouseRequired, message: "Informe sua profissão do Cônjuge" }]}
          />
        </Col>
      </Row>
      <Row gutter={30}>
        <UploadDocumentButton
          trade={props.trade}
          setLoading={props.setLoading}
          title={"RG/CNH do Cônjuge"}
          dontReloadTrade={true}
          hoverTextDisabled="Documento já enviada."
          uploadCategory={DocumentCategoryEnum.ID_SPOUSE}
          storageType={StorageTypeEnum.S3}
        />
      </Row>
    </PbrCard>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/EditTradeSpouse/EditTradeSpouse.tsx